import React from 'react';

class CheckboxGroup extends React.Component {
  checkboxGroup() {
    const {label, required, options, input, meta, onChangeCustom} = this.props;

    return options.map((option, index) => {
      const name = `${input.name}[${index}]`;
      return ([
        <input type="checkbox"
          key={`input_${index}`}
          name={name}
          value={option.id}
          id={name}
          checked={input.value.includes(option.id) && !option.disabled}
          disabled={option.disabled}
          onChange={(event) => {
            const newValue = [...input.value];
            if (event.target.checked) {
              newValue.push(option.id);
            } else {
              newValue.splice(newValue.indexOf(option.id), 1);
            }
            const ret = input.onChange(newValue);
            if (onChangeCustom != null) {
              onChangeCustom(event);
            }
            return ret;
          }}/>,
        <label key={`label_${index}`} htmlFor={name}>{option.name}</label>
      ]);
    });
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.checkboxGroup()}
      </div>
    );
  }
}

export default CheckboxGroup;
